import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

type Store = {
  hospitalList: [],
  setHospitalList: (by: []) => void,

  selectHospitalList: [],
  setSelectHospitalList: (by: []) => void,

  selectPackageList1: [],
  setSelectPackageList1: (by: []) => void,
  selectPackageList2: [],
  setSelectPackageList2: (by: []) => void,
  selectPackageList3: [],
  setSelectPackageList3: (by: []) => void,

  searchHospitalObj1: {
    hosName: string,
    region: string,
  },
  setSearchHospitalObj1: (by: any) => void,
  // setSearchHospitalObj1: (name: any, value: any) => void,

  searchHospitalObj2: {
    hosName: string,
    region: string,
  },
  setSearchHospitalObj2: (by: any) => void,
  // setSearchHospitalObj2: (name: any, value: any) => void,

  searchHospitalObj3: {
    hosName: string,
    region: string,
  },
  setSearchHospitalObj3: (by: any) => void,
  // setSearchHospitalObj3: (name: any, value: any) => void,

  searchPackage1: {
    pkgId: string,
    name: string,
  },
  setSearchPackage1: (by: any) => void,
  searchPackage2: {
    pkgId: string,
    name: string,
  },
  setSearchPackage2: (by: any) => void,
  searchPackage3: {
    pkgId: string,
    name: string,
  },
  setSearchPackage3: (by: any) => void,

  inspectionView: boolean,
  setInspectionView: (by: boolean) => void,

  inspectionList1: [],
  setInspectionList1: (by: []) => void,
  inspectionList2: [],
  setInspectionList2: (by: []) => void,
  inspectionList3: [],
  setInspectionList3: (by: []) => void,

  pkgList: [],
  setPkgList: (idx: any, value: any) => void,

  totalInspectionItems: [],
  setTotalInspectionItems: (by: []) => void,

  selectIpClassList: [],
  setSelectIpClassList: (by: []) => void,

  selectInjectionList: [],
  setSelectInjectionList: (idx: any, value: any) => void,

  ipClassList: [],
  setIpClassList: (idx: number, value: any) => void,

  addInjectionList: [],
  setAddInjectionList: (idx: any, value: any) => void,

  clear: () => void

  /*  reservationId: string
    setReservationId: (by: string) => void*/
}

const useComparisonHospitalStore = create<Store>()(
  devtools(
    persist(
      (set) => ({
        hospitalList: [],
        setHospitalList: (by: []) => set((state) => ({ hospitalList: by })),

        selectHospitalList: [],
        setSelectHospitalList: (by: []) => set((state) => ({ selectHospitalList: by })),

        selectPackageList1: [],
        setSelectPackageList1: (by: []) => set((state) => ({ selectPackageList1: by })),
        selectPackageList2: [],
        setSelectPackageList2: (by: []) => set((state) => ({ selectPackageList2: by })),
        selectPackageList3: [],
        setSelectPackageList3: (by: []) => set((state) => ({ selectPackageList3: by })),

        searchHospitalObj1: {
          hosName: '',
          region: '',
        },
        setSearchHospitalObj1: (by: any) => set((state) => ({ searchHospitalObj1: by })),
        // setSearchHospitalObj1: (name: any, value: any) => set((state: any) => {
        //   state.searchHospitalObj1[name] = value;
        //   return {}
        // }),
        searchHospitalObj2: {
          hosName: '',
          region: '',
        },
        setSearchHospitalObj2: (by: any) => set((state) => ({ searchHospitalObj2: by })),
        // setSearchHospitalObj2: (name: any, value: any) => set((state: any) => {
        //   state.searchHospitalObj2[name] = value;
        //   return {}
        // }),
        searchHospitalObj3: {
          hosName: '',
          region: '',
        },
        setSearchHospitalObj3: (by: any) => set((state) => ({ searchHospitalObj3: by })),
        // setSearchHospitalObj3: (name: any, value: any) => set((state: any) => {
        //   state.searchHospitalObj3[name] = value;
        //   return {}
        // }),

        searchPackage1: {
          pkgId: '',
          name: '',
        },
        setSearchPackage1: (by: any) => set((state) => ({ searchPackage1: by })),
        searchPackage2: {
          pkgId: '',
          name: '',
        },
        setSearchPackage2: (by: any) => set((state) => ({ searchPackage2: by })),
        searchPackage3: {
          pkgId: '',
          name: '',
        },
        setSearchPackage3: (by: any) => set((state) => ({ searchPackage3: by })),


        inspectionView: false,
        setInspectionView: (by: boolean) => set((state) => ({ inspectionView: by })),

        inspectionList1: [],
        setInspectionList1: (by: []) => set((state) => ({ inspectionList1: by })),
        inspectionList2: [],
        setInspectionList2: (by: []) => set((state) => ({ inspectionList2: by })),
        inspectionList3: [],
        setInspectionList3: (by: []) => set((state) => ({ inspectionList3: by })),

        pkgList: [],
        setPkgList: (idx: any, value: any) => set((state: any) => {
          state.pkgList[idx] = value;
          return {}
        }),

        totalInspectionItems: [],
        setTotalInspectionItems: (by: []) => set((state) => ({ totalInspectionItems: by })),

        selectIpClassList: [],
        setSelectIpClassList: (by: []) => set((state) => ({ selectIpClassList: by })),

        selectInjectionList: [],
        setSelectInjectionList: (idx: any, value: any) => set((state: any) => {
          state.selectInjectionList[idx] = value;
          return {}
        }),

        ipClassList: [],
        setIpClassList: (idx: number, value: any) => set((state: any) => {
          state.ipClassList[idx] = value;
          return {}
        }),

        addInjectionList: [],
        setAddInjectionList: (idx: any, value: any) => set((state: any) => {
          state.addInjectionList[idx] = value;
          return {}
        }),

        clear: () => set((state) => ({
          searchHospitalObj1: { hosName: '', region: '' },
          searchHospitalObj2: { hosName: '', region: '' },
          searchHospitalObj3: { hosName: '', region: '' },
          searchPackage1: { pkgId: '', name: '' },
          searchPackage2: { pkgId: '', name: '' },
          searchPackage3: { pkgId: '', name: '' },
          inspectionView: false,
          pkgList: [],
          totalInspectionItems: [],
          selectIpClassList: [],
          selectInjectionList: [],
          ipClassList: [],
          addInjectionList: [],
        })),

        /*  reservationId: '',
          setReservationId: (by: string) => set((state) => ({ reservationId: by })),*/
      }),

      { name: 'comparisonHospitalStore' },
    ),
  ),
)

export default useComparisonHospitalStore;
